import { createRouter, createWebHistory } from "vue-router";
import { sources } from "@/reusable";
const routes = [
  {
    path: "/",
    name: "Application Form",
    component: () => import("../views/LeadsForm.vue"), // adjust path
    beforeEnter: async (to, from, next) => {
      const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
        const [name, value] = cookie.split("=");
        acc[name] = decodeURIComponent(value);
        return acc;
      }, {});

      try {
        if (to.query.source) {
          if (cookies.source) {
            to.meta.source = cookies.source;
            document.cookie = `source=${encodeURIComponent(
              cookies.source
            )}; path=/; Secure; SameSite=Strict`;
          } else {
            if (sources.includes(to.query.source)) {
              to.meta.source = to.query.source;
              document.cookie = `source=${encodeURIComponent(
                to.query.source
              )}; path=/; Secure; SameSite=Strict`;
            } else {
              return next({ name: "NotFound" });
            }
          }
        }
        if (to.query.campaign) {
          // Check if 'campaign' cookie exists
          if (cookies.campaign) {
            to.meta.campaign = cookies.campaign;
            console.log("Campaign cookie already set:", cookies.campaign);
            document.cookie = `campaign=${encodeURIComponent(
              cookies.campaign
            )}; path=/; Secure; SameSite=Strict`;
          } else {
            to.meta.campaign = to.query.campaign;
            console.log("Setting new campaign cookie:", to.query.campaign);
            document.cookie = `campaign=${encodeURIComponent(
              to.query.campaign
            )}; path=/; Secure; SameSite=Strict`;
          }
        }
        if (to.query.referrer) {
          if (cookies.referrer) {
            to.meta.referrer = cookies.referrer;
            console.log("referrer cookie already set:", cookies.referrer);
            document.cookie = `referrer=${encodeURIComponent(
              cookies.referrer
            )}; path=/; Secure; SameSite=Strict`;
          } else {
            to.meta.referrer = to.query.referrer;
            console.log("Setting new campaign cookie:", to.query.referrer);
            document.cookie = `referrer=${encodeURIComponent(
              to.query.referrer
            )}; path=/; Secure; SameSite=Strict`;
          }

          // to.meta.referrer = { campaign: to.query.referrer};
          // document.cookie = `referrer=${encodeURIComponent(to.query.referrer)}; path=/; Secure; SameSite=Strict`;
        }
        next();
      } catch (error) {
        console.error("Failed to fetch leads:", error);
        next(false); // Cancel navigation or redirect
      }
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/ErrorView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
  routes,
});

export default router;
